import 'whatwg-fetch'
import 'intersection-observer'
import EventEmitter from 'eventemitter3'

import BlockFactory from './scripts/support/BlockFactory'
import thumb from './scripts/support/thumb'
export * from './common.blocks'

// NodeList#forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach
}

const firstScriptTag = document.getElementsByTagName('script')[0]

export default blocks => {
	/**
	 * Dit stuk geeft een melding wanneer de environment nog op development staat
	 * Dit hoeft niet weggehaald te worden als gecompiled wordt als productie,
	 * hier zorgt de compiler voor.
	 */
	if (process.env.NODE_ENV === 'development') {
		// eslint-disable-next-line no-console
		console.log(
			'%cdevelopment build',
			'font-size:2em;width:100%;color:#A3303D;padding:0 1em;'
		)
	}

	/**
	 * Initiate thumb script
	 */
	thumb()

	Object.keys(blocks).forEach(block => {
		Array.from(document.querySelectorAll(`.${blocks[block].title}`))
			.filter(element => !element.hasAttribute('data-no-js'))
			.forEach((element, index) => BlockFactory.create(blocks[block], element, index === 0))

	})
}
